import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clientToken: null,
  paymentProcessing: false,
};

export const braintreeSlice = createSlice({
  name: 'braintree',
  initialState,
  reducers: {
    getClientTokenSuccess: (state, action) => {
      const { clientToken } = action.payload || {};
      state.clientToken = clientToken;
    },
    checkout: (state) => {
      state.paymentProcessing = true;
    },
    checkoutFailure: (state) => {
      state.paymentProcessing = false;
    },
    reset: (state) => {
      state.paymentProcessing = false;
      state.clientToken = null; // optional: reset this too
    },
  },
});

export const { getClientTokenSuccess, reset, checkout, checkoutFailure } = braintreeSlice.actions;

export const selectBraintree = (state) => state.braintree;

export const selectClientToken = (state) => state.braintree.clientToken;

export default braintreeSlice.reducer;
